<p style="text-align: center;">
  <small><a href="https://www.quovado.com/it/privacy-policy" target="_blank">Privacy Policy</a></small>
  <span hidden-xs>&nbsp;•&nbsp;</span>
  <small><a href="https://www.quovado.com/it/cookie-policy" target="_blank">Cookie Policy</a></small>
  <span hidden-xs>&nbsp;•&nbsp;</span>
  <small><a href="https://go.quovado.com/condizioni-generali-blogger" target="_blank">Condizioni Generali
      Travel Designer</a></small>
</p>